export const FixedSidebarWithIcons= ({menuModel})=>{
    return <div className="sideBar">
        {menuModel.map((item,index)=>{
            return <p key={index}  title={item.title} onClick={item.onClick}><i className={`fa fa-${item.icon} fa-lg`}></i></p>
        })}
    </div>
}